/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderVkontakteComOauthOptions } from './FxIdApplicationPublicDataBuilderVkontakteComOauthOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions,
    FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSON,
    FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderVkontakteComOauthOptions';

/**
 * @type FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth = FxIdApplicationPublicDataBuilderVkontakteComOauthOptions;

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSON(json: any): FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions(json)) {
        return FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSONTyped(value?: FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions(value)) {
        return FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSON(value as FxIdApplicationPublicDataBuilderVkontakteComOauthOptions);
    }

    return {};
}

